// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pult-language[data-v-4e4d52ce]{display:inline-flex;gap:2px;padding:3px;border:1px solid var(--pult-line);border-radius:8px}button[data-v-4e4d52ce]{background:transparent;border:0;border-radius:5px;padding:5px 7px;font-size:11px;color:var(--pult-muted);cursor:pointer}button[aria-pressed=true][data-v-4e4d52ce]{color:var(--pult-accent);background:var(--pult-soft)}button[data-v-4e4d52ce]:focus-visible{outline:2px solid var(--pult-accent)}", ""]);
// Exports
module.exports = exports;
